import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode, setMode, setAccent, setLang, setIndustry } from './themeSlice';
import type { ThemeMode, AccentColor, Lang, Industry, ThemeState } from './types';

type RootWithTheme = { theme: ThemeState };

export function useTheme() {
  const dispatch = useDispatch();
  const { mode, accent, lang, industry } = useSelector((s: RootWithTheme) => s.theme);

  return {
    mode,
    accent,
    lang,
    industry,
    isDark: mode === 'dark',
    toggleMode: useCallback(() => dispatch(toggleMode()), [dispatch]),
    setMode: useCallback((m: ThemeMode) => dispatch(setMode(m)), [dispatch]),
    setAccent: useCallback((a: AccentColor) => dispatch(setAccent(a)), [dispatch]),
    setLang: useCallback((l: Lang) => dispatch(setLang(l)), [dispatch]),
    setIndustry: useCallback((i: Industry) => dispatch(setIndustry(i)), [dispatch])
  };
}
